import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
  type FilterChipStyleOverrides,
  type InputChipStyleOverrides,
  type AngelouCSS,
} from "@newsela/angelou";

import { rootChipCss } from "@/search/Langston/FilterPanel/FilterPanel.styles";
import { SEARCH_PAGE_BREAKPOINTS } from "@/search/Langston/SearchPage/SearchPage.constants";

const { mediaQuery: breakpoint } = mediaQueryStyles;
const { heading5Obj } = typographyStyles;
const { ui } = constants.colors;

export const filterControlsContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  borderTop: `1px solid ${ui.neutral[100]}`,
  gap: "12px",
  padding: "12px 0",
};

export const selectedFiltersChipGroupCss: FilterChipStyleOverrides<AngelouCSS> =
  {
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
  };

export const selectedFilterCss = (
  hideChip: boolean,
): InputChipStyleOverrides<AngelouCSS> => ({
  root: {
    ...rootChipCss,
    border: "none",
    padding: "4px 8px",
    display: hideChip ? "none" : "block",

    [breakpoint.upTo(SEARCH_PAGE_BREAKPOINTS.MD)]: {
      padding: "8px 12px",
    },
  },
});

export const headingCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  gap: "8px",
};

export const headerText: CSSObject = {
  ...heading5Obj,
  marginBlock: 0,
};

export const expandCollapseContainerCss: CSSObject = {
  display: "flex",
  justifyContent: "center",
};

export const expandCollapseCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
};

export const expandCollapseIconCss = [
  {
    width: "16px",
    height: "16px",
  },
];

export const clearButtonCss = {
  root: {
    padding: "4px 8px",
    borderRadius: "6px",
  },
};

export const expandCollapseButtonCss = {
  root: {
    padding: "4px 8px",
    borderRadius: "6px",
  },
};
